import { CADASTRO_ACTION } from '../Pesquisa/PesquisarTituloCompromisso.constants';


export const routeName = acao => [`${acao === CADASTRO_ACTION ? 'Novo ' : 'Editar '}Cadastro de Títulos de Compromisso`];
export const FIELD_LABEL = 'Título de Compromisso*';
export const SUBTITLE_FORM = 'Informe o Título de Compromisso';
